module.exports = __webpack_public_path__ + "static/media/read-icon.0b6f9ff0.svg";